import PersonIcon from '@mui/icons-material/Person'
import { Button, Container, FormControlLabel, Grid, Link, Radio, RadioGroup, TextField, Typography } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import React, { useContext, useState } from 'react'
import { Link as RouterLink } from "react-router-dom"
import Utilities from '../classes/Utilities'
import { Heading, PasswordField } from '../components'
import { AppContext } from '../context/AppContextProvider'

const useStyles = makeStyles((theme) => ({
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(3),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}))

export default function Register(props) {
    const { paths, features, showMessage, showError, socket } = useContext(AppContext)
    const [waiting, setWaiting] = useState(false)
    const [complete, setComplete] = useState(false)
    const [existingProfile, setExistingProfile] = useState(true)
    const classes = useStyles()

    async function handleSubmit(event) {
        event.preventDefault()

        setWaiting(true)

        try {
            const values = Utilities.getFormValues(event.target)

            const response = await socket.send('register', {
                step: 'register',
                existingProfile,
                firstName: values.firstName,
                lastName: values.lastName,
                email: values.email,
                sms: values.sms,
                password: values.password,
            })

            showMessage(response, { variant: 'success' })
            setComplete(true)

        } catch (err) {
            showError(err)
            setWaiting(false)
        }
    }

    return (
        <Container maxWidth="xs">
            <Heading icon={<PersonIcon />}>
                Register
            </Heading>
            {!complete &&
                <form className={classes.form} onSubmit={handleSubmit}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <RadioGroup value={existingProfile} onChange={() => setExistingProfile(!existingProfile)} >
                                <FormControlLabel value={true} control={<Radio />} label="I am already in the system at this location" disabled={waiting} />
                                <FormControlLabel value={false} control={<Radio />} label="I am not yet in the system at this location" disabled={waiting || !features.allow_new_signups} />
                            </RadioGroup>
                        </Grid>
                        {!existingProfile &&
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    id="firstName"
                                    name="firstName"
                                    label="First Name"
                                    variant="outlined"
                                    autoComplete="fname"
                                    required
                                    fullWidth
                                    disabled={waiting}
                                />
                            </Grid>
                        }
                        {!existingProfile &&
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    id="lastName"
                                    name="lastName"
                                    label="Last Name"
                                    variant="outlined"
                                    autoComplete="lname"
                                    required
                                    fullWidth
                                    disabled={waiting}
                                />
                            </Grid>
                        }
                        <Grid item xs={12}>
                            <TextField
                                id="email"
                                name="email"
                                label="Email Address"
                                variant="outlined"
                                type="email"
                                autoComplete="email"
                                required
                                fullWidth
                                helperText={existingProfile ? 'Must match the email address on-file' : undefined}
                                disabled={waiting}
                            />
                        </Grid>
                        {!existingProfile &&
                            <Grid item xs={12}>
                                <TextField
                                    id="sms"
                                    name="sms"
                                    label="Mobile Number"
                                    type="tel"
                                    variant="outlined"
                                    autoComplete="mobile"
                                    fullWidth
                                    disabled={waiting}
                                />
                            </Grid>
                        }
                        <Grid item xs={12}>
                            <PasswordField
                                id="password"
                                name="password"
                                label="Password"
                                variant="outlined"
                                autoComplete="off"
                                required
                                fullWidth
                                helperText="Choose a password to use when logging in"
                                disabled={waiting}
                            />
                        </Grid>
                    </Grid>
                    <Button
                        className={classes.submit}
                        type="submit"
                        variant="contained"
                        color="primary"
                        fullWidth
                        disabled={waiting}
                    >
                        Register
                    </Button>
                    <Grid container justifyContent="flex-end">
                        <Grid item>
                            <Link component={RouterLink} to={paths.root} variant="body2" underline="hover">Already have an account?</Link>
                        </Grid>
                    </Grid>
                </form>
            }
            {complete &&
                <form className={classes.form}>
                    <Grid container spacing={2}>
                        <Typography>
                            An account verification email has been sent to your email address. Please check your inbox.
                        </Typography>
                    </Grid>
                    <p></p>
                    <Grid container justifyContent="flex-end">
                        <Grid item>
                            <Link component={RouterLink} to={paths.root} ariant="body2" underline="hover">Back to Login</Link>
                        </Grid>
                    </Grid>
                </form>
            }
        </Container>
    )
}
